import { Link } from 'react-router-dom'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner'
import { Table } from 'reactstrap'
import { GET_STATISTICS_SUMMARY_QUERY } from '../../graphql'

const GET_STATISTICS_SUMMARY = gql(GET_STATISTICS_SUMMARY_QUERY)

export default function StatisticsSummary({ parameters }) {
  console.log('StatisticsSummary rendered: ', parameters)

  const { loading, error, data } = useQuery(GET_STATISTICS_SUMMARY, {
    variables: {
      fromDate: parameters.fromDate,
      toDate: parameters.toDate
    }
  })
  if (loading) {
    return <Spinner />
  }
  if (error) {
    return <div>{error.message}</div>
  }

  const rows = []
  if (data.getStatisticsSummary) {
    let queryString = ''
    queryString += parameters.fromDate ? `&fromDate=${parameters.fromDate}` : ''
    queryString += parameters.toDate ? `&toDate=${parameters.toDate}` : ''
    data.getStatisticsSummary.forEach((dataRow, index) => {
      const row =
        <tr key={index}>
          <td data-cy={dataRow.eventName.toLowerCase().replace(/ /g,'-')}><Link to={`/statistics?eventId=${dataRow.eventId}${queryString}`}>{dataRow.eventName}</Link></td>
          <td className="right">{dataRow.count}</td>
          <td className="right">{dataRow.avgSeconds}</td>
          <td className="right">{dataRow.minSeconds}</td>
          <td className="right">{dataRow.maxSeconds}</td>
        </tr >
      rows.push(row)
    })
  }

  return (
    <div className="statistics-grid-container">
      <div className="statistics-grid-header">
        <h3>Statistics Summary</h3>
      </div>
      <div className="statistics-grid-table-container">
        <Table className="statistics-grid-table" bordered size="sm">
          <thead>
            <tr>
              <th>Event</th>
              <th>Count</th>
              <th>Avg Seconds</th>
              <th>Min Seconds</th>
              <th>Max Seconds</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
      </div>
    </div>
  )
}